module.exports = __webpack_public_path__ + "img/l.81f1f106.webp";